import types from './types.js';

const showPreviousEvents = () => ({
    type: types.SHOW_PREVIOUS_EVENTS,
});

const changeDeviceType = (deviceType) => ({
    type: types.CHANGE_DEVICE_TYPE,
    deviceType
});

export default {
    showPreviousEvents,
    changeDeviceType
};
